import { PalletSpec } from '@freight-cbm/shared-types';

export const PALLET_SPECS: PalletSpec[] = [
  {
    type: 'Euro Pallet (1200×800)',
    length: 1.2,
    width: 0.8,
    maxStackHeight: 1.8,
    maxWeightKg: 1500,
  },
  {
    type: 'US Standard (48×40 in)',
    length: 1.219,
    width: 1.016,
    maxStackHeight: 1.8,
    maxWeightKg: 2000,
  },
  {
    type: 'Australian (1165×1165)',
    length: 1.165,
    width: 1.165,
    maxStackHeight: 1.8,
    maxWeightKg: 2000,
  },
];
